import axiosObj from "./axios";

// Uncomment below code for testing APIs with latency

// function sleep(ms) {
//   return new Promise((resolve) => setTimeout(resolve, ms));
// }

// const fetcher = (url, params = {}) => {
//   console.log("I got called with url: ", url);
//   return sleep(5000).then(() =>
//     axiosObj.get(url, { params: params }).then((res) => {
//       return res.data;
//     })
//   );
// };

// Uncomment below code for testing APIs with error

// const fetcher = (url, params = {}) =>
//   axiosObj.get(url, { params: params }).then((res) => {
//     const error = new Error("An error occurred while fetching the data.");
//     throw error;
//   });

const fetcher = (url, params = {}) => {
  return axiosObj.get(url, { params: params }).then((res) => {
    return res.data;
  });
};

export default fetcher;
